import { useAuth } from 'context'
import { GetCustomComponentList, GetCustomReport } from 'hooks'
import { FormSteps } from 'page-components'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Step } from 'semantic-ui-react'
import styled from 'styled-components'
import { CustomReportSteps } from 'utility'

const ReportContainer = styled.div`
  .steps  {
    width: 100%;
  }
`

export const AddEditCustomReportScreen = () => {
  const { user } = useAuth()
  const { id } = useParams()
  const { data, filterChanged, setData } = GetCustomReport()
  const { data: componentList } = GetCustomComponentList()
  const [steps, setSteps] = useState(CustomReportSteps)

  useEffect(() => {
    filterChanged({ companyId: user.CompanyId, templateId: id, callFrom: 1 })
  }, [])

  const onSectionSelect = (section, sectionData) => {
    setData({
      ...data,
      ReportComponentSection: data.ReportComponentSection.map(ele => ({
        ...ele,
        IsSelected: ele.SubsectionID === section ? sectionData.IsSelected : ele.IsSelected,
      })),
    })
  }

  const onDataAdd = (section, sectionData) => {
    setData({
      ...data,
      ReportComponentSection: data.ReportComponentSection.map(ele => ({
        ...ele,
        data: section.SubsectionID === section ? sectionData : ele.data,
      })),
    })
  }

  const onStepChange = (key) => {
    setSteps(steps.map(ele => ({ ...ele, active: key === ele.key || false })))
  }

  return (
    <ReportContainer>
      <div className="col-12">
        <Step.Group items={steps} className="step" />
      </div>
      <FormSteps
        sectionList={data}
        componentList={componentList}
        onSectionSelect={onSectionSelect}
        onDataAdd={onDataAdd}
        onStepChange={onStepChange}
        activeStep={steps.find(ele => ele.active).key}
      />
    </ReportContainer>
  )
}